<div class="page-body">
    <div class="expanding-box-conforming">
        <app-spinner *ngIf="loading"></app-spinner>
        <div *ngIf="!tinkSuccess && !loading" style="text-align: center;">
            Ett oväntat fel har uppstått
        </div>
    </div>
</div>